import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Select from 'react-select-legacy';
import { Link } from 'react-router-dom';
import { isEmpty, join, split, trim } from 'lodash';
import { linkWithParams } from 'routes';
import { formatMapIds, formatMapNames } from 'utils/Formatters';

export default class AccountPlayerDetails extends React.Component {
  static propTypes = {
    accountPlayer: PropTypes.object.isRequired,
    cohorts: PropTypes.arrayOf(PropTypes.object).isRequired,
    editable: PropTypes.bool.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onResetCohorts: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = { isEdit: false, ...this.initialState() };
  }

  initialState() {
    const { firstName, lastName, cohorts } = this.props.accountPlayer;
    return { firstName, lastName, cohortIds: formatMapIds(cohorts) };
  }

  onCancel = () => {
    this.setState({ isEdit: false });
  }

  onChange = (e) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({ [name]: value });
  }

  onCohortChange = (cohortIds) => {
    this.setState({ cohortIds });
  }

  onEdit = () => {
    this.setState({ isEdit: true, ...this.initialState() });
  }

  onUpdate = () => {
    const { accountPlayer } = this.props;
    const { firstName, lastName, cohortIds } = this.state;
    this.setState({ isEdit: false });
    this.props.onUpdate(accountPlayer.id, { firstName, lastName, cohortIds: split(cohortIds, ',') });
  }

  onResetCohorts = () => {
    if (window.confirm('Do you really want to remove this child from this cohort? You will no longer see this child in your program.')) {
      const { accountPlayer } = this.props;
      this.setState({ isEdit: false });
      this.props.onResetCohorts(accountPlayer.id);
    }
  }

  render() {
    const { isEdit, firstName, lastName, cohortIds } = this.state;
    const { accountPlayer, cohorts, editable } = this.props;
    const clsUpdate = classNames('o-sp-button o-sp-button--update o-sp-button--primary',
      { 'u-disabled': isEmpty(trim(firstName)) || isEmpty(trim(lastName)) || isEmpty(trim(cohortIds)) }
    );

    const careGivers = accountPlayer.careGivers.map(c => (
      <li key={`link-${c.value}`}>
        <Link className='cs-txt-link--sp-blue' to={{ pathname: linkWithParams('account', { id: c.value }) }}>
          {c.label}
        </Link>
      </li>
    ));
    const parentLink = (
      <Link key={`link-${accountPlayer.creator.id}`} className='cs-txt-link--sp-blue' to={{ pathname: linkWithParams('account', { id: accountPlayer.creator.id }) }}>
        {accountPlayer.creator.name} (main)
      </Link>
    )

    return (
      <section className='column o-card cs-bg--light'>
        {!isEdit && editable && <a className='cs-txt-link--sp-blue u-float--right' onClick={this.onEdit}>EDIT</a>}
        {isEdit ? (
          <p className='u-margin-bottom--tiny'>
            <span className='u-txt--label'>Birthday</span><br />
            <input name='birthday' type='text' value={accountPlayer.birthday} disabled />
          </p>
        ) : (
          <p className='u-margin-bottom--tiny'>
            <span className='u-txt--label'>Birthday</span><br />
            {accountPlayer.birthday}
          </p>
        )}
        { accountPlayer.weeksPremature > 0 && (
          <>
            {isEdit && accountPlayer.weeksPremature > 0 ? (
              <p className='u-margin-bottom--tiny'>
                <span className='u-txt--label'>Weeks Premature</span><br />
                <input name='weeksPremature' type='text' value={accountPlayer.weeksPremature} disabled />
              </p>
            ) : (
              <p className='u-margin-bottom--tiny'>
                <span className='u-txt--label'>Weeks Premature</span><br />
                {accountPlayer.weeksPremature}
              </p>
            )}
          </>
        )}
        {isEdit &&
          <p className='u-margin-bottom--tiny'>
            <span className='u-txt--label'>First Name</span><br />
            <input name='firstName' type='text' value={firstName} onChange={this.onChange} />
          </p>}
        {isEdit &&
          <p className='u-margin-bottom--tiny'>
            <span className='u-txt--label'>Last Name</span><br />
            <input name='lastName' type='text' value={lastName} onChange={this.onChange} />
          </p>}
        <ul className='no-bullet u-margin-bottom--tiny'>
          <li><span className='u-txt--label'>Caregivers</span></li>
          <li>{parentLink}</li>
          {careGivers}
        </ul>
        <p className='u-margin-bottom--tiny'>
          <span className='u-txt--label'>Teacher</span><br />
          {isEmpty(accountPlayer.teachers) ? 'None' : join(accountPlayer.teachers, ', ')}
        </p>
        <p className='u-margin-bottom--tiny'>
          <span className='u-txt--label'>Group Name</span><br />
          {join(accountPlayer.groups, ', ')}
        </p>
        <p className='u-margin-bottom--tiny'>
          <span className='u-txt--label'>Subgroup Name</span><br />
          {join(accountPlayer.subgroups, ', ')}
        </p>
        <div className='u-margin-bottom--zero'>
          <span className='u-txt--label'>Cohort</span><br />
          {isEdit ?
            <Select
              name='sp-cohort-select'
              className={'o-select o-select--optcohort'}
              value={cohortIds || ''}
              multi={true}
              onChange={this.onCohortChange}
              options={cohorts}
              placeholder='Select Cohort'
              simpleValue={true} /> : formatMapNames(accountPlayer.cohorts)}
        </div>
        {isEdit &&
          <div className='row align-middle u-margin-top--small'>
            <div className='column'>
              <a className={clsUpdate} onClick={this.onUpdate}>Update</a>
              {this.props.accountPlayer.partnerDefaultGroup &&
                <a className="o-sp-button o-sp-button--update o-sp-button--danger u-margin-top--small" onClick={this.onResetCohorts}>Remove</a>
              }
            </div>
            <div className='column'>
              <a className='o-sp-button--update cs-txt-link--sp-blue' onClick={this.onCancel}>Cancel</a>
            </div>
          </div>}
      </section>
    )
  }
}
